module.exports = __webpack_public_path__ + "static/media/picklesChutneys.efb11107.webp";